<template>
	<Modal
		v-model:visible="visibleModal"
		:title="$t('settings.routeLeaveModal.header')"
		@ok="confirm"
		:closable="false"
	>
		<template #footer>
			<Button key="back" @click="cancel">{{ $t('settings.routeLeaveModal.cancelButtonLabel') }}</Button>
			<Button key="leave" @click="confirm">{{ $t('settings.routeLeaveModal.okButtonLabel') }}</Button>
			<Button v-if="submit != null" key="submit" type="primary" @click="submit()" :loading="loading">{{ submitText }}</Button>
		</template>
		<p>{{ $t('settings.routeLeaveModal.text') }}</p>
	</Modal>
</template>

<script>
import { toRef, computed } from 'vue';
import { Button, Modal } from 'ant-design-vue';

// использовать с этим composable:
// import { useRouteLeaveModal } from '@/components/common/useRouteLeaveModal';
export default {
	components: {
		Button, Modal,
	},
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		confirm: {
			type: Function,
			required: true,
		},
		cancel: {
			type: Function,
			required: true,
		},
		submit: {
			type: Function,
			required: false,
		},
		loading: {
			type: Boolean,
			required: false,
		},
		submitText: {
			type: String,
			required: false,
		},
	},
	setup(props, { emit }) {
		const visibleRef = toRef(props, 'visible');
		const visibleModal = computed({
			get: () => visibleRef.value,
			set: () => emit('update:visible'),
		})
		return {
			visibleModal,
		}
	},
}
</script>
